module.exports = __webpack_public_path__ + "img/a37.8ed3f3ad.svg";